//timeout for ACS token API call
export const ACS_TOKEN_API_TIMEOUT = 6000;
export const ACS_TOKEN_RETRY = 3;
